'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  timeout: 5000,
  responseType: 'json',
  mode: 'cors',
  maxRedirects: 25,
  credentials: 'same-origin',
  cache: 'no-cache',
  method: 'POST'
};